import { CDN_BASE_URL } from 'src/constants/externalUrls';
import {
  CLIENT_FONTFAMILY_OPTIONS,
  CUSTOM_FONT_CONFIG,
  DEFAULT_FONTFAMILY,
} from 'src/constants/fontsConsts';

export interface ResolvedFont {
  fontFamily: string;
  fontCssUrl?: string;
}

/**
 * Resolve font family label and CSS URL from a stored clientFontFamily value.
 * Returns the default font when the viewer is not a client or no custom font is set.
 */
export function resolveFont(
  clientFontFamily: string | undefined,
  isClient: boolean,
): ResolvedFont {
  const fontValue =
    isClient && clientFontFamily ? clientFontFamily : DEFAULT_FONTFAMILY;
  const fontOption = CLIENT_FONTFAMILY_OPTIONS.find(
    (f) => f.value === fontValue,
  );
  const fontFamily = fontOption?.label ?? DEFAULT_FONTFAMILY;

  let fontCssUrl: string | undefined;

  if (fontOption) {
    if (fontOption.type === 'custom') {
      const customConfig = CUSTOM_FONT_CONFIG[fontOption.value];
      if (customConfig) {
        fontCssUrl = `${CDN_BASE_URL}${customConfig.cssPath}`;
      }
    } else {
      fontCssUrl = `https://fonts.googleapis.com/css?family=${fontOption.value}:300,400,500,600,700,800,900&display=swap`;
    }
  }

  return { fontFamily, fontCssUrl };
}
